import { Canvas } from '@react-three/fiber';
import { Suspense, useState, useEffect } from 'react';
import HeroParticles from '../three/HeroParticles';

const Hero = () => {
  const [showScrollIndicator, setShowScrollIndicator] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      // Hide the arrow once user scrolls down
      if (window.scrollY > 100) {
        setShowScrollIndicator(false);
      } else {
        setShowScrollIndicator(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToProjects = () => {
    const element = document.getElementById('projects');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative w-full h-screen flex items-center justify-center overflow-hidden">
      {/* Three.js Background */}
      <div className="absolute inset-0">
        <Canvas
          camera={{ position: [0, 0, 20], fov: 75 }}
          className="particle-canvas"
        >
          <Suspense fallback={null}>
            <HeroParticles count={10000} />
          </Suspense>
        </Canvas>
      </div>

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-bg-dark/50 to-bg-dark pointer-events-none" />

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl">
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading font-bold mb-6 animate-fade-in">
          <span className="block text-shadow-glow">DANIEL OSTROW</span>
        </h1>

        <p className="text-xl md:text-2xl lg:text-3xl text-text-secondary mb-4 animate-slide-up">
          Software Engineer &{' '}
          <span className="text-highlight-marker gradient-text font-semibold">
            Quantum Computing Researcher
          </span>
        </p>

        <p className="text-lg md:text-xl text-text-secondary max-w-3xl mx-auto mb-12 animate-slide-up opacity-90">
          Building the future of AI/ML pipelines and quantum-enabled security systems
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-slide-up">
          <button onClick={scrollToContact} className="btn-primary">
            Get In Touch
          </button>
          <button onClick={scrollToProjects} className="btn-secondary">
            View My Work
          </button>
        </div>

      </div>

      {/* Scroll Indicator - Fixed to bottom of viewport */}
      <div
        className={`fixed bottom-8 left-1/2 transform -translate-x-1/2 z-20 animate-bounce transition-opacity duration-500 ${
          showScrollIndicator ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
      >
        <button
          onClick={scrollToProjects}
          className="cursor-pointer hover:text-quantum-green transition-colors"
          aria-label="Scroll down"
        >
          <svg
            className="w-8 h-8 text-quantum-blue"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 14l-7 7m0 0l-7-7m7 7V3"
            />
          </svg>
        </button>
      </div>
    </section>
  );
};

export default Hero;
